module.exports = __webpack_public_path__ + "img/none-icon.a2f95e99.svg";